import type {MapEvent} from '@/apiTypes/event';
import {DateGroupHeader} from '@/components/dateGroupHeader/dateGroupHeader';
import {MobileEventDetailCard} from '@/components/mobileSearch/mobileEventDetailCard';
import {groupEventsByDate} from '@/utils/groupEventsByDate';
import {FC} from 'react';

interface GroupedEventListProps {
  events: MapEvent[];
  onEventMouseEnter?: (eventId: string) => void;
  onEventMouseLeave?: (eventId: string) => void;
}

/** Vertical list of events grouped by date, used on Lists, profiles, and organizer pages. */
export const GroupedEventList: FC<GroupedEventListProps> = ({
  events,
  onEventMouseEnter,
  onEventMouseLeave,
}) => {
  if (events.length === 0) return null;

  return (
    <div className="flex flex-col gap-6">
      {groupEventsByDate(events).map((group) => (
        <div key={group.dateKey}>
          <DateGroupHeader date={group.date} />
          <div className="flex flex-col gap-4">
            {group.events.map((event) => (
              <MobileEventDetailCard
                key={event.id}
                event={event}
                onMouseEnter={
                  onEventMouseEnter
                    ? () => onEventMouseEnter(event.id)
                    : undefined
                }
                onMouseLeave={
                  onEventMouseLeave
                    ? () => onEventMouseLeave(event.id)
                    : undefined
                }
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
